import {Component, Inject} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {UtilService} from "library";
@Component({
  selector: 'app-app.layout',
  templateUrl: './app.layout.component.html'
})
export class AppLayoutComponent {
  displaySidebar: boolean = false;
  showComponent: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document, 
                protected utilService: UtilService) {
    let themeLink = this.document.getElementById('app-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = 'krediya.v2-theme.css';
    }

    this.utilService.enablePageLoading();

    setTimeout(() => {
      this.showComponent = true;
    }, 1000);
  }

  toggleSidebar() {
    this.displaySidebar = !this.displaySidebar
  }
}
